import { Flex, View } from '@smarterservices/smarter-ui';
import React, { useEffect, useState, useLayoutEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMediaStart } from '../../helpers/helpers';
import { config } from '../../config';
import { ReactChat } from '@smarterservices/react-chat';

// Custom hook to get the window height in pixels
const useWindowHeight = () => {
  const [windowHeight, setWindowHeight] = useState(0);

  useLayoutEffect(() => {
    // Function to update the height state
    const updateHeight = () => {
      setWindowHeight(window.innerHeight);
    };

    // Set initial height
    updateHeight();

    // Add event listener for window resize
    window.addEventListener('resize', updateHeight);

    // Clean up event listener on unmount
    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  return windowHeight;
};

const TextChat = () => {
  const windowHeight = useWindowHeight();
  const containerRef = useRef(null);
  const navigate = useNavigate();
  const [params, setParams] = useState(null);

  useEffect(() => {
    const initChat = async () => {
      let chatParams = JSON.parse(sessionStorage.getItem('spChatParams'));
      if (!chatParams) {
        // There were no params stored, so we need to get them from the URL
        const url = new URL(window.location.href);
        chatParams = new Proxy(new URLSearchParams(url.search), {
          get: (searchParams, prop) => searchParams.get(prop),
        });
        if (
          !chatParams ||
          !chatParams.token ||
          !chatParams.roomId ||
          !chatParams.identity ||
          !chatParams.referenceId
        ) {
          // missing params, redirect to the page
          navigate('/missing-params');
          return;
        }

        // Get the user's display name and the websocket url to add to the params
        const response = await getMediaStart(
          chatParams.identity,
          chatParams.token
        );

        // Store the params to be used
        chatParams = {
          roomId: chatParams.roomId,
          identity: chatParams.identity,
          token: chatParams.token,
          referenceId: chatParams.referenceId,
          websocketUrl: response.websocketUrl,
          displayName: response.displayName,
        };

        sessionStorage.setItem('spChatParams', JSON.stringify(chatParams));

        // clear the params from the url
        url.search = '';
        window.history.replaceState({}, document.title, url);
      }

      setParams(chatParams);
    };
    initChat();
  }, [navigate]);

  // Calculate the container height based on window height
  const containerHeight = windowHeight > 0 ? `${windowHeight}px` : '100vh';

  return params ? (
    <Flex direction="column" width="100%" height="auto">
      <View as="div" height={containerHeight} width="100%">
        <Flex
          direction="column"
          height="100%"
          width="100%"
          as="div"
          overflow="auto"
          elementRef={(el) => {
            containerRef.current = el;
          }}
        >
          <ReactChat
            roomId={params.roomId}
            identity={params.identity}
            token={params.token}
            referenceId={params.referenceId}
            apiUrl={config.proctoring.api.baseUrl}
            websocketUrl={params.websocketUrl}
            displayName={params.displayName}
          />
        </Flex>
      </View>
    </Flex>
  ) : null;
};

export default TextChat;
